import Vue from 'vue';
import i18n from '@/plugins/i18n';

export default ({ text = i18n.t('error.alert'), color = 'error', icon = '', timeout = -1 }) => {
  Vue.prototype.$eventHub.$emit('snackbar', { text, color, icon, timeout });
};
